import { Component, computed, inject, input, Signal } from '@angular/core';
import {
  TransactionItemFromAPI,
  TransactionItemTemplateDisplay,
  VatType,
} from '../../../../../../_interfaces/transactions.interface';
import { convertAPIItemsToTemplateDisplay, returnVatTypeLabel } from '../../_helpers/transactions-helpers';
import { CurrencyPipe, NgClass } from '@angular/common';
import { EmptyIndicatorPipe } from '../../../../../../shared/pipes/empty-indicator.pipe';
import { AccountingService } from '../../../_services/accounting/accounting.service';
import { AccountingConnectionStatus } from '../../../../../../_interfaces/accounting.interface';

@Component({
  selector: 'app-transaction-split-categories-view',
  imports: [CurrencyPipe, EmptyIndicatorPipe, NgClass],
  templateUrl: './transaction-split-categories-view.component.html',
})
export class TransactionSplitCategoriesViewComponent {
  accountingService = inject(AccountingService);
  taxRates = this.accountingService.taxRates;

  savedItems = input<TransactionItemFromAPI[]>([]); // Items from API if transaction is already split

  // Computed signal that converts API items to template-friendly format
  splitItemsTemplateData = computed<TransactionItemTemplateDisplay[]>(() => {
    const savedItems = this.savedItems();

    if (savedItems.length === 0) {
      return [];
    }

    // Use helper function to convert API format to template format
    return convertAPIItemsToTemplateDisplay(savedItems);
  });

  protected hasActiveConnection: Signal<boolean> = computed(() => {
    return this.accountingService.connectionStatus() === AccountingConnectionStatus.Complete;
  });

  // Get tax rate object from ID for display
  getTaxRate(taxId: number | undefined) {
    if (!taxId) return undefined;
    return this.taxRates().find((rate) => rate.id === taxId);
  }

  protected readonly VatType = VatType;
  protected readonly returnVatTypeLabel = returnVatTypeLabel;
}
